import { render } from "./ActionsColumn.vue?vue&type=template&id=04995f40&scoped=true"
import script from "./ActionsColumn.vue?vue&type=script&lang=js"
export * from "./ActionsColumn.vue?vue&type=script&lang=js"

import "./ActionsColumn.vue?vue&type=style&index=0&id=04995f40&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-04995f40"

export default script